// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__CY5Un","container":"style_container__8chNX","contacts":"style_contacts__2cMuO","contact":"style_contact__G3kms","phone":"style_phone__e5qU_"};